import React from 'react';
import styles from '../../styles/stats-widget-placeholders.module.scss'
import classNames from "classnames";

export const MatchEventModulePlaceholderRound = () => {
  return (
    <div className={classNames(styles.round_container)}>
      <div className={classNames(styles.round)}>
        <div className={classNames(styles.blank_round)}/>
      </div>
    </div>
  )
};
